import React from 'react';
import assign from 'object-assign';

import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import { Card, CardText } from 'material-ui/Card';

import UserGroupActions from '../../actions/UserGroupActionCreator';
import UserGroupStore from '../../stores/UserGroupStore';

const url = '/dashboard/usergroups';

const UserGroupForm = React.createClass({

    getInitialState: function () {
        return {
            isEdit: (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/)),
            details: {
                id: '',
                name: '',
                description: ''
            }
        }
    },

    componentDidMount: function() {
        UserGroupStore.addChangeListener(this.onChange);
        if(this.state.isEdit) {
            UserGroupActions.getById(this.props.routeParams.id);
        }
    },

    componentWillUnmount: function() {
        UserGroupStore.removeChangeListener(this.onChange);
    },

    render: function () {

        const formTitle  = (this.props.routeParams.id === undefined ? 'New usergroup' : 'Edit');
        const redirectTo = (this.state.isEdit ? '/dashboard/usergroup/' + this.state.details.id : url);

        return(
            <Form
                title={formTitle}
                onSave={this.onSave}
                redirectTo={redirectTo}
            >
                <Card className="cent-card">
                    <CardText>
                        <TextField
                            name="name"
                            value={this.state.details.name}
                            validations="minLength:2,maxLength:80"
                            validationError="Please use only numbers and letters, at least 2"
                            hintText="Name"
                            floatingLabelText="Name"
                            required
                        />
                        <TextField
                            name="description"
                            value={this.state.details.description}
                            multiLine={true}
                            validations="maxLength:120"
                            validationError="Please use only numbers and letters"
                            hintText="Description"
                            floatingLabelText="Description"
                        />
                    </CardText>
                </Card>
            </Form>
      );
    },

    onSave: function (model) {
        if(this.props.routeParams.id === undefined) {
            return UserGroupActions.save(model);
        } else {
            return UserGroupActions.update(this.props.routeParams.id, model);
        }
    },

    onChange: function() {
        this.setState(assign({}, this.state, {
            details: UserGroupStore.getById(this.props.routeParams.id)
        }));
    }
});

export default UserGroupForm;
